import * as React from "react";
const SvgGoOut = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 8.5V4.5L21 11.5L14 18.5V14.4C9 14.4 5.5 16 3 19.5C4 14.5 7 9.5 14 8.5Z", fill: "currentColor" }));
export default SvgGoOut;
